import { formatDateToDDMMYYYY } from '@/fsd/shared/lib/helpers/formatDateToDDMMYYYY/formatDateToDDMMYYYY';
import { transformFilters } from '@/fsd/shared/ui/static/js/transformFilters';

export const transformAcceptancesListFilters = (
  filters: Record<string, unknown>
) => {
  const transformedFilters = transformFilters({
    date_from: formatDateToDDMMYYYY(
      Array.isArray(filters.date) ? filters.date?.[0] : ''
    ),
    date_to: formatDateToDDMMYYYY(
      Array.isArray(filters.date) ? filters.date?.[1] : ''
    ),
    counterparty_ids: filters.counterparty,
    conducted: filters.conducted,
    type: filters.status,
    organisation_ids: filters.organisation,
    sender_warehouse_ids: filters.sender_warehouse,
    receiver_warehouse_ids: filters.receiver_warehouse,
    product_ids: filters.products,
    warehouse_ids: filters.warehouse,
  });

  return transformedFilters;
};
